export const EQUIPMENT_TYPES = [
  { value: 'DRY_VAN', label: 'Dry Van' },
  { value: 'REEFER', label: 'Reefer (Refrigerated)' },
  { value: 'FLATBED', label: 'Flatbed' },
  { value: 'STEP_DECK', label: 'Step Deck' },
  { value: 'LOWBOY', label: 'Lowboy' },
  { value: 'TANKER', label: 'Tanker' },
  { value: 'INTERMODAL', label: 'Intermodal' },
  { value: 'BOX_TRUCK', label: 'Box Truck' },
  { value: 'SPRINTER_VAN', label: 'Sprinter Van' },
  { value: 'POWER_ONLY', label: 'Power Only' },
  { value: 'HOTSHOT', label: 'Hotshot' },
  { value: 'CONESTOGA', label: 'Conestoga' },
  { value: 'DOUBLE_DROP', label: 'Double Drop' },
  { value: 'RGN', label: 'RGN (Removable Gooseneck)' }
];

export const getEquipmentLabel = (value) => {
  const type = EQUIPMENT_TYPES.find(t => t.value === value);
  return type ? type.label : value;
};

export default EQUIPMENT_TYPES;
